// Languages supported by the application
export const SUPPORTED_LANGUAGES = ['en', 'de', 'fr', 'es'];
export const DEFAULT_LANGUAGE = 'en';

// Where the switcher remembers the visitor's choice (client.ts also mirrors it into a cookie).
export const LANGUAGE_STORAGE_KEY = 'i18nextLng';

/**
 * Turns whatever sits in storage into a language we ship, or null.
 *
 * Region tags are accepted by their language part: i18next's old browser detector wrote
 * values like `de-DE`, and a visitor who still has one should get German, not English.
 * Anything else (empty, tampered, a language we dropped) is ignored rather than trusted.
 */
export function resolveStoredLanguage(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const language = raw.trim().toLowerCase().split(/[-_]/)[0];
  return SUPPORTED_LANGUAGES.includes(language) ? language : null;
}
